
import { Component, Prop, Vue } from 'vue-property-decorator'
import InformationPanelMain from '@/components/organisms/InformationPanelMain.vue'
import InformationPanelStudent from '@/components/organisms/InformationPanelStudent.vue'
import { AvatarCode } from '@/const/AvatarCode'

/**
 * 左側メニューのインフォメーションパネル
 */
@Component({
  components: {
    InformationPanelMain,
    InformationPanelStudent,
  },
})
export default class SidemenuInformationPanel extends Vue {
  /** 新着お知らせの有無 */
  @Prop()
  private hasNewNotice!: boolean

  /** お知らせボタン押下時のイベント */
  @Prop()
  private noticeUrl!: string

  /** ビューモードボタン押下時のイベント */
  @Prop()
  private eventClickToggleViewModeButton!: () => void

  /** 生徒情報：編集ボタン押下時のイベント */
  @Prop()
  private eventClickEditButton!: () => void

  /** 生徒情報：ログアウトボタン押下時のイベント */
  @Prop()
  private eventClickLogoutButton!: () => void

  /** 生徒情報：パスワード変更ボタン押下時のイベント */
  @Prop()
  private eventClickChangePasswordButton!: () => void

  /** 生徒情報：メールアドレス変更ボタン押下時のイベント */
  @Prop()
  private eventClickChangeMailAddressButton!: () => void

  /** 生徒情報 */
  private student = this.$appCookies.authStudent.get()

  /** 生徒情報の表示非表示 */
  private showStudentPanel: boolean = false

  /**
   * 生徒ニックネーム
   *
   * @returns cookie保持している生徒ニックネーム
   */
  private get studentNickName(): string {
    return this.student.nickname
  }

  /**
   * 生徒ID
   *
   * @returns cookie保持している生徒ID
   */
  private get studentId(): string {
    return this.student.loginId
  }

  /**
   * 塾名(校名)
   *
   * @returns cookie保持している塾名+教室名
   */
  private get schoolName(): string {
    return `${this.student.academyName} ${this.student.branchName}`
  }

  /**
   * アイコン画像URL
   *
   * @returns url
   */
  private get imageUrl(): string {
    // TODO 画像配置がs3だった場合、処理追加
    const icon = AvatarCode.findByCode(this.student.avatarIconCode)
    return icon.path
  }

  /**
   * 生徒情報の表示切り替え
   */
  private toggleStudentPanel(): void {
    this.showStudentPanel = !this.showStudentPanel
  }
}
